import { Field, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import { checkExistingOrg } from "../../../_redux/organization/organizationCrud";
import { SIMPZ_STATUS_ARRAY } from "../OrganizationUIHelpers";
import { CORPORATION } from "../../../../../config/environment";
import AsyncSelect from "react-select/async";
import { genOptionLoaderDebounced } from "../../../../../../_metronic/_helpers/fetchUtils";
import {
  findOrganizationRegional,
  findAllOrgRegional
} from "../../../_redux/organization-regional/organizationRegionalCrud";
import { useSelector } from "react-redux";

const validationSchema = Yup.object({
  username: Yup.string().required("Nama User tidak boleh kosong!"),
  org_name: Yup.string().required("Nama Organisasi tidak boleh kosong!"),
  domain_name: Yup.string()
    .required("Mohon masukkan Domain Organisasi")
    .matches(/^[aA-zZ\s]+$/, "Special Character Tidak Diperbolehkan"),
  email: Yup.string()
    .email()
    .required("Email tidak boleh kosong"),
  password: Yup.string().required(),
  confirmationPassword: Yup.string().when("password", {
    is: password => password && password.length > 0,
    then: Yup.string()
      .oneOf(
        [Yup.ref("password"), null],
        "Konfirmasi password harus sama dengan password!"
      )
      .required("Konfirmasi password wajib diisi!")
  })
});

export default function OrganizationCreateForm({ onSubmit }) {
  const [currentTimeout, setCurrentTimeout] = useState(null);
  const [regionalList, setRegionalList] = useState([]);

  const { user } = useSelector(state => state.auth);

  // const checkDomainName = async (value = "") => {
  //   clearTimeout(currentTimeout);
  //   return new Promise((resolve, reject) => {
  //     setCurrentTimeout(
  //       setTimeout(() => {
  //         checkExistingOrg({
  //           domain_name: value.toLowerCase() + ".donorian.com"
  //         }).then(res => {
  //           if (res.data.data) {
  //             resolve("Nama Domain sudah terdaftar!");
  //           } else {
  //             resolve();
  //           }
  //         });
  //       }, 250)
  //     );
  //   });
  // };

  useEffect(() => {
    const fetchOrgRegional = async () => {
      findAllOrgRegional()
        .then(({ data }) => {
          let dataOptions = data.data.map(item => {
            return {
              value: item.uuid,
              label: item.name
            };
          });
          setRegionalList(dataOptions);
        })
        .catch(err => {
          setRegionalList([]);
        });
    };

    fetchOrgRegional();
  }, []);

  return (
    <Formik
      initialValues={{
        simpz_status: "DATA_UPLOAD"
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        setFieldValue,
        handleSubmit,
        handleBlur,
        errors,
        touched,
        values
      }) => {
        console.log(values);
        return (
          <>
            <div className="form-group row">
              <div className="col">
                <Field
                  name="org_name"
                  label="Nama Organisasi"
                  component={Input}
                  placeholder="Masukkan nama organisasi"
                />
              </div>
              <div className="col">
                <label>
                  <strong>Nama Domain</strong>
                </label>
                <Form.Group>
                  <InputGroup hasValidation>
                    <Field
                      name="domain_name"
                      component={Form.Control}
                      aria-describedby="inputGroupPrepend"
                      placeholder="Domain organisasi"
                      required
                      onChange={e =>
                        setFieldValue(
                          "domain_name",
                          `${e.target.value}`.toLowerCase()
                        )
                      }
                      // validate={checkDomainName}
                    />
                    <InputGroup.Text id="inputGroupPrepend">
                      {CORPORATION.toLowerCase() == "donorian"
                        ? ".donorian.com"
                        : ".simpz.id"}
                    </InputGroup.Text>
                  </InputGroup>
                  {touched.domain_name && errors.domain_name && (
                    <div style={{ color: "red" }}>{errors.domain_name}</div>
                  )}
                </Form.Group>
              </div>
              <div className="col">
                <label>
                  <strong>Status</strong>
                </label>
                <Select
                  name="simpz_status"
                  onChange={e => {
                    setFieldValue("simpz_status", e.target.value);
                  }}
                  onBlur={handleBlur}
                >
                  {SIMPZ_STATUS_ARRAY.map((item, i) => (
                    <option key={i} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <Field
                  name="username"
                  label="Nama User"
                  component={Input}
                  placeholder="Nama User"
                />
              </div>
              <div className="col">
                <Field
                  name="email"
                  label="Email User"
                  type="email"
                  component={Input}
                  placeholder="Email User"
                />
              </div>
            </div>
            {!user.regional_uuid && (
              <div className="form-group row">
                <div className="col-lg-12">
                  <label>
                    <strong>Regional</strong>
                  </label>
                  <AsyncSelect
                    defaultOptions={regionalList}
                    loadOptions={genOptionLoaderDebounced(
                      inputValue =>
                        findOrganizationRegional({
                          pageNumber: 1,
                          pageSize: 10,
                          filter: {
                            name: inputValue
                          }
                        }),
                      ({ uuid, name }) => ({ label: name, value: uuid })
                    )}
                    value={
                      values.regional_uuid
                        ? {
                            label: values.regional_name,
                            value: values.regional_uuid
                          }
                        : null
                    }
                    placeholder
                    onChange={e => {
                      const { value, label } = e ?? {};
                      setFieldValue("regional_uuid", value);
                      setFieldValue("regional_name", label);
                    }}
                    isClearable
                  />
                </div>
              </div>
            )}
            <div className="form-group row">
              <div className="col">
                <Field
                  name="password"
                  label="Password"
                  type="password"
                  component={Input}
                  placeholder="Password"
                />
              </div>
              <div className="col">
                <Field
                  name="confirmationPassword"
                  label="Konfirmasi Password"
                  type="password"
                  component={Input}
                  placeholder="Konfirmasi Password"
                />
              </div>
            </div>
            <button
              className="btn btn-primary float-right"
              onClick={handleSubmit}
            >
              Simpan
            </button>
          </>
        );
      }}
    </Formik>
  );
}
